import CryptoJS from "crypto-js";
import { getData } from "../utils/storeData";
import axios from "./instance";

export const getPlayers = () => {
  const token = getData("tt");
  return axios({
    url: `/users/players`,
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).then((res) => res);
};

export const getComments = () => {
  const token = getData("tt");
  return axios({
    url: `/users/comments`,
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).then((res) => res);
};

export const oktaLogIn = (username, password) => {
  const encodedUsername = CryptoJS.enc.Base64.stringify(
    CryptoJS.enc.Utf8.parse(username)
  );
  const encodedPassword = CryptoJS.enc.Base64.stringify(
    CryptoJS.enc.Utf8.parse(password)
  );
  return axios({
    url: `/users/aut`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      u: encodedUsername,
      p: encodedPassword,
    },
  }).then((res) => {
    return res;
  });
};

export const adminLogIn = (username, password) => {
  const encodedUsername = CryptoJS.enc.Base64.stringify(
    CryptoJS.enc.Utf8.parse(username)
  );
  const encodedPassword = CryptoJS.enc.Base64.stringify(
    CryptoJS.enc.Utf8.parse(password)
  );
  return axios({
    url: `/users/autadmin`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      u: encodedUsername,
      p: encodedPassword,
    },
  }).then((res) => res);
};

export const addComment = (_, comment, worldType) => {
  const token = getData("tt");
  return axios({
    url: `/users/comment`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: {
      comment,
      worldType,
    },
  }).then((res) => res);
};
